/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordWithTokenRequest
 */
export interface ResetPasswordWithTokenRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    readonly $schema?: string;
    /**
     * Password
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    password: string;
    /**
     * Recaptcha token
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    recaptchaToken: string;
    /**
     * Retrieve device keys
     * @type {boolean}
     * @memberof ResetPasswordWithTokenRequest
     */
    retrieveDeviceKeys: boolean;
    /**
     * Token
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    token: string;
}

/**
 * Check if a given object implements the ResetPasswordWithTokenRequest interface.
 */
export function instanceOfResetPasswordWithTokenRequest(value: object): value is ResetPasswordWithTokenRequest {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    if (!('retrieveDeviceKeys' in value) || value['retrieveDeviceKeys'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ResetPasswordWithTokenRequestFromJSON(json: any): ResetPasswordWithTokenRequest {
    return ResetPasswordWithTokenRequestFromJSONTyped(json, false);
}

export function ResetPasswordWithTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordWithTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'password': json['password'],
        'recaptchaToken': json['recaptcha_token'],
        'retrieveDeviceKeys': json['retrieve_device_keys'],
        'token': json['token'],
    };
}

export function ResetPasswordWithTokenRequestToJSON(json: any): ResetPasswordWithTokenRequest {
    return ResetPasswordWithTokenRequestToJSONTyped(json, false);
}

export function ResetPasswordWithTokenRequestToJSONTyped(value?: Omit<ResetPasswordWithTokenRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'recaptcha_token': value['recaptchaToken'],
        'retrieve_device_keys': value['retrieveDeviceKeys'],
        'token': value['token'],
    };
}

